import { render, staticRenderFns } from "./PromoterStatistics.vue?vue&type=template&id=2a9f71d8&scoped=true&"
import script from "./PromoterStatistics.vue?vue&type=script&lang=js&"
export * from "./PromoterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PromoterStatistics.vue?vue&type=style&index=0&id=2a9f71d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9f71d8",
  null
  
)

export default component.exports